import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOrganization } from '../contexts/OrganizationContext';
import type { Role } from '../schemas/types';
import { AlertCircleIcon, HomeIcon } from 'lucide-react';
export function ProtectedRoute({
  children,
  allowed
}: {
  children: React.ReactNode;
  allowed: Role[];
}) {
  const {
    role
  } = useAuth();
  const {
    language,
    t
  } = useOrganization();
  // Get translations with fallbacks
  const translations = {
    accessDenied: t.accessDenied || 'Access Denied',
    accessDeniedMessage: language === 'en' ? 'You do not have permission to access this page.' : language === 'uk' ? 'У вас немає дозволу на доступ до цієї сторінки.' : "Vous n'avez pas la permission d'accéder à cette page.",
    returnToDashboard: t.dashboard ? `Return to ${t.dashboard}` : 'Return to Dashboard',
    currentRole: language === 'en' ? 'Your current role' : language === 'uk' ? 'Ваша поточна роль' : 'Votre rôle actuel',
    requiredRole: language === 'en' ? 'Required role' : language === 'uk' ? 'Необхідна роль' : 'Rôle requis'
  };
  if (!allowed.includes(role)) {
    return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-8" data-id="element-351">
        <div className="max-w-2xl w-full" data-id="element-352">
          <div className="bg-white rounded-2xl shadow-sm border-2 border-gray-200 overflow-hidden" data-id="element-353">
            {/* Header */}
            <div className="bg-gradient-to-r from-red-600 to-red-700 px-8 py-8" data-id="element-354">
              <div className="flex items-center justify-center mb-4" data-id="element-355">
                <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center" data-id="element-356">
                  <AlertCircleIcon className="w-12 h-12 text-white" data-id="element-357" />
                </div>
              </div>
              <h1 className="text-3xl font-bold text-white text-center mb-2" data-id="element-358">
                {translations.accessDenied}
              </h1>
              <p className="text-red-100 text-center text-lg" data-id="element-359">
                {translations.accessDeniedMessage}
              </p>
            </div>
            {/* Content */}
            <div className="p-8" data-id="element-360">
              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-361">
                <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-4" data-id="element-362">
                  <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2" data-id="element-363">
                    {translations.currentRole}
                  </div>
                  <div className="text-lg font-bold text-gray-900 capitalize" data-id="element-364">
                    {role.replace('-', ' ')}
                  </div>
                </div>
                <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4" data-id="element-365">
                  <div className="text-xs font-semibold text-red-600 uppercase tracking-wide mb-2" data-id="element-366">
                    {translations.requiredRole}
                  </div>
                  <div className="text-lg font-bold text-red-700 capitalize" data-id="element-367">
                    {allowed.join(' or ').replace(/-/g, ' ')}
                  </div>
                </div>
              </div>
              <Link to="/dashboard" className="w-full px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-3 font-semibold text-lg" data-id="element-368">
                <HomeIcon className="w-6 h-6" data-id="element-369" />
                {translations.returnToDashboard}
              </Link>
            </div>
          </div>
        </div>
      </div>;
  }
  return <>{children}</>;
}